<template><div><h1>VUX V2.6.2 发布日志</h1>
<h2><a href="/zh-CN/components/checklist.html">Checklist</a></h2>
<ul><li>[feature] 支持 max=1 交互为单选模式 #1996</li>
</ul>
<h2><a href="/zh-CN/components/picker.html">Picker</a></h2>
<ul><li>[enhance] 滚动距离支持从 html[data-dpr] 换算 #1979</li>
</ul>
<h2><a href="/zh-CN/components/x-address.html">XAddress</a></h2>
<ul><li>[fix] 更新地址数据 #2000</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.6.2 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.6.2-255.vue?6ecf739f